import {
  Box,
  Button,
  Card,
  Grid,
  Modal,
  Tooltip,
  TooltipProps,
  Typography,
  styled,
  tooltipClasses,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import FormApprovationRequest from "./FormApprovationRequest";
import { convertHexToRGB } from "app/utils/utils";
import {
  AnnouncementOutlined,
  ArrowRightAltOutlined,
  CheckOutlined,
} from "@mui/icons-material";
import { getAvaliableUserProfiles } from "app/services/profileServices/Profile";
import SnackbarProvider from "app/components/SnackbarProvider";
import { MatxLoading } from "app/components";
import { notify } from "app/utils/notifyUtils";

const StyledCard = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  textAlign: "center",
  position: "relative",
  padding: "24px !important",
  background: `rgb(${convertHexToRGB(
    theme.palette.primary.main
  )}, 0.08) !important`,
  [theme.breakpoints.down("sm")]: { padding: "16px !important" },
}));

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: "#fff",
    textAlign: "center",
    //maxWidth: 220,
    fontSize: theme.typography.pxToRem(24),
    border: "1px solid #dadde9",
    padding: "15px",
  },
}));

export interface ProfileResponseData {
  name: string;
  role: string;
  id: number;
  active: number;
  comment: string;
}

const UserProfileList = () => {
  const [profiles, setProfiles] = useState<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [approvationModalOpen, setApprovationModalOpen] = React.useState(false);
  const [selectedProfile, setSelectedProfile] = useState<ProfileResponseData>();
  const handleOpen = () => setApprovationModalOpen(true);
  const handleClose = () => setApprovationModalOpen(false);
  const snackbarProvider = SnackbarProvider();

  const handleClick = (value: ProfileResponseData) => {
    setSelectedProfile(value);
    handleOpen();
  };

  const request = async () => {
    const data = await getAvaliableUserProfiles();
    setProfiles(data);
  };

  useEffect(() => {
    setLoading(true);
    try {
      request();
    } catch (e) {
      notify("error", "Erro ao carregar perfis. Tente novamente.");
    } finally {
      setLoading(false);
    }
  }, []); // eslint-disable-line

  if (loading) {
    return (
      <div style={{ height: "10vh" }}>
        <MatxLoading />
      </div>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 3,
        width: "100%",
        mx: "auto",
      }}
    >
      <Grid container spacing={2} sx={{ padding: "5px", marginTop: "10px" }}>
        {profiles?.data.response
          .filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.id === item.id)
          )
          .map((item) => (
            <Grid item xs={4} key={item.id} sx={{ padding: "10px" }}>
              <HtmlTooltip
                placement="bottom"
                arrow
                title={
                  <React.Fragment>
                    <AnnouncementOutlined />
                    <Typography color="inherit">{item.comment}</Typography>
                  </React.Fragment>
                }
              >
                <StyledCard>
                  <img
                    src={require(`../../../assets/icons/${item.icon}.png`)}
                    alt="logo"
                    width={100}
                  />

                  <Typography
                    sx={{
                      marginBottom: 3,
                      marginTop: 3,
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#000",
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Button
                    size="large"
                    color="inherit"
                    variant="outlined"
                    sx={{ textTransform: "normal" }}
                    onClick={() => handleClick(item)}
                    disabled={item.active === 0 || item.active === 1}
                    endIcon={
                      item.active === 1 ? (
                        <CheckOutlined fontSize="small" />
                      ) : (
                        <ArrowRightAltOutlined fontSize="small" />
                      )
                    }
                  >
                    {item.active === 0
                      ? "Aguardando Aprovação"
                      : item.active === 1
                      ? "Perfil Ativo"
                      : "Ativar Perfil"}
                  </Button>
                </StyledCard>
              </HtmlTooltip>
            </Grid>
          ))}
      </Grid>
      <Modal
        open={approvationModalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <FormApprovationRequest
            selectedProfile={selectedProfile}
            reloadPrevComponent={request}
            handleClose={handleClose}
          />
        </div>
      </Modal>
    </Box>
  );
};

export default UserProfileList;
